import React, { useMemo } from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { Column, InfoIcon, Row } from './HomeForm.styles'

/**
 * The InformationMessage's component.
 */
const InformationMessage = () => {
  const {
    size: { isUpToLarge, isMedium, isDownToSmall, isDownToMedium }
  } = useViewport()

  const paddingCard = useMemo(() => {
    if (isUpToLarge) {
      return '24px 128px'
    }

    if (isMedium) {
      return '24px 64px'
    }

    if (isDownToSmall) {
      return '24px'
    }
  }, [isDownToSmall, isUpToLarge, isMedium])

  return (
    <Card color="warning" padding={paddingCard}>
      <Row alignItems="flex-start" justifyContent={isDownToMedium ? 'center' : 'flex-start'}>
        <Column lg={0.4} md={0.4}>
          <InfoIcon />
        </Column>
        <Column lg={11.6} md={11.6}>
          <Typography color="black1" fontSize="16px" lineHeight="21px" variant="body1">
            Te recordamos que{' '}
            <strong>eres el responsable de la correcta gestión de pasajes aéreos nacionales del organismo</strong> al
            cual perteneces, por tanto, todas las acciones que registres, incluido el resguardo del buen uso de recursos
            fiscales, serán de tu absoluta responsabilidad.
          </Typography>
        </Column>
      </Row>
    </Card>
  )
}

export default InformationMessage
